module.exports = __webpack_public_path__ + "static/media/18.7fe36bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/18.png
// module id = 977
// module chunks = 0